import { Modal } from 'shared/ui/Modal/Modal';
import { Button } from '../../shared/ui/Button/Button';
import { Form, Formik } from 'formik';
import React from 'react';
import { Label } from 'flowbite-react';
import { Select } from '../../shared/ui/form/Select/Select';
import { TextArea } from '../../shared/ui/form/TextArea';

import * as Yup from 'yup';
import { useBillMutations } from '../../entities/bill/model';
import { useCurrentUserDetails } from '../../entities/user/model';
import { toast } from 'react-toastify';
export const FormSchema = Yup.object().shape({
  paymentStatus: Yup.string().oneOf(['unpaid', 'paid']).required(),
  cryptoTransactionHash: Yup.string().nullable(),
});

export const UpdatePaymentStatusModal = ({ bill, onClose }) => {
  const { getCurrentOrganizationId } = useCurrentUserDetails();
  const { update } = useBillMutations();
  const _handleSubmit = async (values, { setSubmitting }) => {
    try {
      await update.mutateAsync({
        billId: bill._id,
        params: {
          paymentStatus: values.paymentStatus,
          transactionHash: values.cryptoTransactionHash,
          paymentDate: new Date().toISOString().slice(0, 10),
          organization: getCurrentOrganizationId(),
        },
      });
      onClose();
      toast.success('Updated Bill Payment Status');
    } catch (err) {
      toast.error('Failed to Update Bill Payment Status');
    }
  };

  return (
    <Modal dismissible show={!!bill} onClose={onClose}>
      <Formik
        validationSchema={FormSchema}
        initialValues={{
          paymentStatus: bill?.paymentStatus || 'unpaid',
          cryptoTransactionHash: bill?.transactionHash || '',
        }}
        onSubmit={_handleSubmit}>
        {({ isSubmitting, values, validateForm, setFieldValue, errors }) => {
          return (
            <Form>
              <Modal.Header className="dark:border-none">
                Update Payment Status
              </Modal.Header>
              <Modal.Body>
                <div className="grid gap-y-4">
                  <div className="grid text-left gap-y-2">
                    <Label className="!text-slate-400" value="Payment Status" />
                    <Select
                      name={'paymentStatus'}
                      id={'paymentStatus'}
                      disabled={isSubmitting}
                      sizing="md"
                      color="darkSlate"
                      value={values.paymentStatus}
                      onChange={(evt) => {
                        setFieldValue('paymentStatus', evt.target.value);
                      }}>
                      <option value="" disabled>
                        --
                      </option>
                      <option value="paid">Paid</option>
                      <option value="unpaid">Unpaid</option>
                    </Select>
                  </div>
                  <div className="grid text-left gap-y-2">
                    <Label
                      className="!text-slate-400"
                      value="Transaction Hash (Optional)"
                    />

                    <TextArea
                      rows="4"
                      name={'cryptoTransactionHash'}
                      id={'cryptoTransactionHash'}
                      value={values.cryptoTransactionHash}
                      disabled={isSubmitting}
                      onChange={(evt) => {
                        setFieldValue(
                          'cryptoTransactionHash',
                          evt.target.value
                        );
                      }}
                      sizing="sm"
                      placeholder={'0x...'}
                      color="darkSlate"
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className="justify-end dark:border-none">
                <Button color="slate" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  isProcessing={isSubmitting}
                  type="submit"
                  color="indigo">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};
